module.exports = __webpack_public_path__ + "static/media/logo-vorwerk@2x.2f3b250d.png";